module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-nav-item-dropdown', {
    attrs: {
      "text": "About"
    }
  }, [_c('b-dropdown-item', {
    on: {
      "click": function($event) {
        _vm.goTo({
          name: 'announcements'
        })
      }
    }
  }, [_vm._v("Announcements")]), _vm._v(" "), _c('b-dropdown-item', {
    on: {
      "click": function($event) {
        _vm.goTo({
          name: 'history'
        })
      }
    }
  }, [_vm._v("History")]), _vm._v(" "), _c('b-dropdown-item', {
    on: {
      "click": function($event) {
        _vm.goTo({
          name: 'aimsAndScope'
        })
      }
    }
  }, [_vm._v("Aims & Scope")]), _vm._v(" "), _c('b-dropdown-item', {
    on: {
      "click": function($event) {
        _vm.goTo({
          name: 'employees'
        })
      }
    }
  }, [_vm._v("Employees")]), _vm._v(" "), _c('b-dropdown-item', {
    staticClass: "hidden-sm-up",
    on: {
      "click": function($event) {
        _vm.goTo({
          name: 'ethicsAndMalpractice'
        })
      }
    }
  }, [_vm._v("Ethics & Malpractice")]), _vm._v(" "), _c('b-dropdown-item', {
    on: {
      "click": function($event) {
        _vm.goTo({
          name: 'careers'
        })
      }
    }
  }, [_vm._v("Careers")]), _vm._v(" "), _c('b-dropdown-item', {
    on: {
      "click": function($event) {
        _vm.goTo({
          name: 'contact'
        })
      }
    }
  }, [_vm._v("Contact")]), _vm._v(" "), _c('b-dropdown-item', {
    on: {
      "click": function($event) {
        _vm.goTo({
          name: 'sponsorshipRequest'
        })
      }
    }
  }, [_vm._v("Sponsorship Request")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2641a35d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/main-layout/header-nav/dropdowns/AboutDropdownComponent.vue
// module id = 1407
// module chunks = 1